<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm món ăn</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <DishForm ref="dishForm" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DishForm from '@/modules/dish/DishForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DishForm
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      description: '',
      name: ''
    }
  },
  computed: {},
  methods: {
    ...mapActions('Dishes', ['createDish', 'uploadImage']),
    cancel() {
      this.dialog = false
      this.reset()
      this.$refs.form.resetValidation()
    },
    async save() {
      if (!this.$refs.dishForm.validate()) return
      this.$loading.active = true
      try {
        const data = this.$refs.dishForm.getData()
        const dish = await this.createDish({
          name: data.name,
          type: data.type
        })

        if (data.image) {
          let formData = new FormData()
          formData.append('files', data.image)
          formData.append('refId', dish.id)
          formData.append('ref', 'dish')
          formData.append('field', 'image')
          await this.uploadImage(formData)
        }

        this.dialog = false
        this.$alert.addSuccess()
      } catch (error) {
        console.error(error)
        this.$alert.addError(error)
      } finally {
        this.$loading.active = false
      }
    },
    reset() {
      this.status = 'active'
      this.name = null
      this.driver = null
      this.maxStudent = null
      this.description = null
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>
